<template>
  <div>
    <p class="font-semibold text-sm cursor-pointer">
      <VaIcon
        v-if="props.withIcon"
        name="edit_calendar"
        class="cursor-pointer"
        @click="
          () => {
            activePicker = !activePicker
          }
        "
      />
      {{ activeDate }}
    </p>

    <div
      v-if="activePicker"
      class="block absolute bg-white z-10 p-3 pb-0 shadow rounded-lg"
      style="z-index: 999"
      @mouseleave="
        () => {
          activePicker = false
        }
      "
    >
      <VaDatePicker v-model="cDate" :max-date="maxDate" :max="maxDate" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { formatDate } from 'date-fns'
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'

const props = withDefaults(
  defineProps<{
    date?: string
    withIcon?: boolean
  }>(),
  {
    date: '',
    withIcon: true,
  },
)
const maxDate = new Date()
const cDate = ref(maxDate)
// const emit = defineEmits<{
//   (e: 'initialized', editor: typeof MediumEditor): void
// }>()

const activePicker = ref(false)

const activeDate = computed(() => cDate.value && formatDate(cDate.value, 'dd/MM/yyyy'))

onMounted(() => {
  //
  if (props.date) {
    cDate.value = new Date(props.date)
  }
})

onBeforeUnmount(() => {
  //
})
</script>

<style lang="scss">
@import 'variables';
</style>
